import { generateUUID } from '~/utils/lib/core/prelude'

/**
 * @typedef {{
 *   source: string;
 *   type: string;
 *   eventId: string;
 *   scope: Record<string, any>;
 *   payload: any;
 *   occurredAt: string;
 *   raw: any;
 * }} RealtimeEnvelope
 */

/**
 * @param {string} source
 * @param {string|Record<string, any>} data
 * @returns {RealtimeEnvelope}
 */
export function normalizeRealtimeMessage(source, data) {
  const raw = parsePayload(data)
  const type = toStringValue(
    raw.type || raw.event || raw.name || 'message'
  )
  const eventId = toStringValue(
    raw.eventId || raw.event_id || raw.id || generateUUID()
  )
  const scope = asObject(raw.scope)
  const payload = raw.payload === undefined ? raw : raw.payload
  const occurredAt = toStringValue(
    raw.occurredAt || raw.occurred_at || new Date().toISOString()
  )

  return {
    source,
    type,
    eventId,
    scope,
    payload,
    occurredAt,
    raw,
  }
}

/**
 * @param {string|Record<string, any>} data
 * @returns {Record<string, any>}
 */
function parsePayload(data) {
  if (typeof data === 'object' && data !== null)
    return data

  if (typeof data !== 'string')
    return {}

  try {
    const parsed = JSON.parse(data)
    return asObject(parsed)
  } catch (_) {
    return {
      payload: data,
      type: 'raw',
    }
  }
}

/**
 * @param {any} value
 * @returns {Record<string, any>}
 */
function asObject(value) {
  if (typeof value === 'object' && value !== null && !Array.isArray(value))
    return value

  return {}
}

/**
 * @param {any} value
 * @returns {string}
 */
function toStringValue(value) {
  if (typeof value === 'string')
    return value

  return String(value)
}

